import styled from "styled-components";

export const Styles = styled.label`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0rem;
  cursor: pointer;

  .simple-checkbox-input {
    width: 18px;
    height: 18px;
    cursor: pointer;
    accent-color: var(--main-color);
  }

  .simple-checkbox-label {
    font-size: 0.875rem;
    color: #4a5568;
    user-select: none;
  }
`;
